import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Radio, RadioProps } from '@clds/radio';
import { Textarea } from '@clds/text-area-old';
import { FieldLayout, GroupLayout, InlineFieldLayout, Label, LabelProps } from '@clds/form';
import { messages } from '../../i18n';
import { DisplayAssetsFormData, Justification } from '../../types';

export interface DisplayAssetsFormProps {
  formData: DisplayAssetsFormData;
  onChange: (formData: DisplayAssetsFormData) => void;
}

const Root = styled.div`
  > :not(:first-of-type) {
    margin-top: ${(props) => props.theme.spacing.lg};
  }
`;

export const DisplayAssetsFormFields: FC<DisplayAssetsFormProps> = ({ formData, onChange, ...rest }) => {
  const { formatMessage } = useIntl();

  const radioProps = (option: Justification): RadioProps => ({
    id: `display-assets-question1-${option}`,
    name: 'display-assets-question1',
    checked: formData.justification === option,
    onChange: () => onChange({ ...formData, justification: option }),
  });
  const labelProps = (option: Justification): PropsWithChildren<LabelProps> => ({
    htmlFor: `display-assets-question1-${option}`,
    children: <FormattedMessage {...messages[`loginAsDisplayAssetsModalContentQuestion1_${option}`]} />,
  });

  return (
    <Root {...rest}>
      <FieldLayout
        layout="vertical"
        label={
          <Label mandatory>
            <FormattedMessage {...messages.loginAsDisplayAssetsModalContentQuestion1} />
          </Label>
        }
      >
        <GroupLayout>
          <InlineFieldLayout label={<Label {...labelProps('zendesk')} />}>
            <Radio {...radioProps('zendesk')} />
          </InlineFieldLayout>
          <InlineFieldLayout label={<Label {...labelProps('jira')} />}>
            <Radio {...radioProps('jira')} />
          </InlineFieldLayout>
          <InlineFieldLayout label={<Label {...labelProps('session')} />}>
            <Radio {...radioProps('session')} />
          </InlineFieldLayout>
          <InlineFieldLayout label={<Label {...labelProps('suspicious')} />}>
            <Radio {...radioProps('suspicious')} />
          </InlineFieldLayout>
          <InlineFieldLayout label={<Label {...labelProps('other')} />}>
            <Radio {...radioProps('other')} />
          </InlineFieldLayout>
          <Textarea
            data-test-specifier="details"
            value={formData.details}
            onChange={(details) => onChange({ ...formData, details })}
            minRows={4}
            id="display-assets-question2"
            placeholder={formatMessage(messages.loginAsDisplayAssetsModalContentPlaceholder)}
          />
        </GroupLayout>
      </FieldLayout>
    </Root>
  );
};
